import React, { useEffect, useState } from 'react';
import CompDatePicker from './compDatePicker/_CompDatePicker';
import { Select } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { setBranchesData } from '../app-context/policyProduction';
import { RootState } from '../app-context/store';


type InputProps = {
    onChange: Function;
    data: any;
    stationUserIdProps?: string;
}
const StationUserSelect = (props: InputProps) => {
    const [branches, setBranches] = useState<any[] | null>(null);
    const [users, setUsers] = useState<any[] | null>(null);
    const [branchId, setBranchId] = useState<string | null>(null);
    const [projectName, setProjectName] = useState<string | undefined>(undefined);
    const [projects, setProjects] = useState<any[]>([]);
    const [selectedBranchObject, setSelectedBranchObject] = useState<any | undefined>(undefined);
    const [selectedProjectObject, setSelectedProjectObject] = useState<any | undefined>(undefined);
    const [subBranches, setSubBranches] = useState<any[]>([]);
    const [subBranchesAll, setSubBranchesAll] = useState<any[]>([]);
    const [subBranchName, setSubBranchName] = useState<string | undefined>(undefined);
    const [stationUsers, setStationUsers] = useState<any[]>([]);
    const [stationUsersAll, setStationUsersAll] = useState<any[]>([]);
    const [stationUserName, setStationUserName] = useState<string | undefined>(undefined);
    const [isLoaded, setIsLoaded] = useState<boolean>(false);

    const [userDisabled, setUserDisabled] = useState<boolean>(false);
    const [branchDisabled, setBranchDisabled] = useState<boolean>(false);
    const [projectDisabled, setProjectDisabled] = useState<boolean>(false);

    const dispatch = useDispatch();
    const brunchesData = useSelector((state: RootState) => state.policyProduction.branchesData);

    const onProjectChange = (e: any) => {
        const search = e.target.value;
        // console.log('onProjectChange', search);
        setProjectName(search);
        dispatch(setBranchesData({ project: search, branch: '', user: '' }));
        if (branches) {
            const selectedBranch = branches.find((b: any, i: number) => b.name === search && b.parentId === null);
            if (selectedBranch) {
                let subBranchesUsers: any[] = [];
                setSelectedProjectObject(selectedBranch);

                selectedBranch.children.forEach((b: any) => {
                    const users: any[] = getBranchUsers(b);
                    // getBranchUsers
                    subBranchesUsers = [...subBranchesUsers, ...users];
                })
                props.onChange({
                    BranchId: selectedBranch.id,
                    stationUserId: undefined
                });
                setSubBranches(selectedBranch.children);
                setStationUsers(subBranchesUsers);
            } else {
                const sbList = subBranchesAll
                setSubBranches(sbList);
                const uList = stationUsersAll;
                setStationUsers(uList);
            }
            // const filtered = branches.filter((b: any, i: number) => b.parentId===null && b.name.indexOf(search) > -1)
        }
        // saveStateData();
    }
    const clearProjectName = () => {
        setProjectName('');
        setSubBranchName('');
        setStationUserName('');
        setSelectedProjectObject(undefined);
        const sbList = subBranchesAll
        setSubBranches(sbList);
        const uList = stationUsersAll;
        setStationUsers(uList);
        props.onChange({
            BranchId: undefined,
            stationUserId: undefined
        });
        // saveStateData();
    }

    const getBranchUsers = (selectedBranch: any) => {
        let branchUsers: any[] = [];
        if (users) {
            branchUsers = users.filter((u: any, i: number) => u.branchId === selectedBranch.id);
            if (selectedBranch.branchManagerId) {
                const branchManager = users.find((u: any, i: number) => u.id === selectedBranch.branchManagerId)
                if (branchManager) {
                    branchUsers.push(branchManager);
                }
            }
            if (selectedBranch.children && selectedBranch.children.length > 0) {
                selectedBranch.children.forEach((branch: any) => {
                    const subBranchUsers = users.filter((u: any, i: number) => u.branchId === branch.id);
                    if (branch.branchManagerId) {
                        const branchManager = users.find((u: any, i: number) => u.id === branch.branchManagerId)
                        if (branchManager) {
                            branchUsers.push(branchManager);
                        }
                    }
                    if (subBranchUsers && subBranchUsers.length > 0) {
                        branchUsers = [...branchUsers, ...subBranchUsers]
                    }
                });
            }
            // setStationUsers(stations);
        }
        // console.log('StationUserSelect selectedBranch', selectedBranch, branchUsers);
        return branchUsers;
    }
    const onSubBranchChange = (e: any) => {
        const search = e.target.value;
        setSubBranchName(search);
        dispatch(setBranchesData({ project: projectName || '', branch: search, user: '' }));
        if (branches) {
            const selectedBranch = branches.find((b: any, i: number) => b.name === search);
            if (selectedBranch) {
                setSelectedBranchObject(selectedBranch);
                props.onChange({
                    BranchId: selectedBranch.id,
                    stationUserId: undefined
                });
                if (users) {
                    let stations: any[] = getBranchUsers(selectedBranch);
                    setStationUsers(stations);
                    // console.log('StationUserSelect selectedBranch', selectedBranch, stations);
                }
            } else {
                const uList = stationUsersAll;
                setStationUsers(uList);
            }

        }
        // saveStateData();
    }

    const clearSubBranchName = () => {
        setSubBranchName('');
        setStationUserName('');
        // setStationUsers([]);
        // const sbList = subBranchesAll
        // setSubBranches(sbList);
        setSelectedBranchObject(undefined);
        props.onChange({
            BranchId: selectedProjectObject ? selectedProjectObject.id : undefined,
            stationUserId: undefined
        });
        if (selectedProjectObject) {
            let subBranchesUsers: any[] = [];
            // const p = branches.find((b: any, i: number)=> b.parentId === selectedBranch.id);
            // setSubBranches(branches.find((b: any, i: number)=> b.parentId === selectedBranch.id));
            selectedProjectObject.children.forEach((b: any) => {
                const users: any[] = getBranchUsers(b);
                // getBranchUsers
                subBranchesUsers = [...subBranchesUsers, ...users];
            })
            props.onChange({
                BranchId: selectedProjectObject.id,
                stationUserId: undefined
            });
            setSubBranches(selectedProjectObject.children);
            setStationUsers(subBranchesUsers);
        } else {

            const uList = stationUsersAll;
            setStationUsers(uList);
        }
        // saveStateData();
    }

    const onStationUserChange = (e: any) => {
        const search = e.target.value;
        setStationUserName(search);
        dispatch(setBranchesData({ project: projectName || '', branch: subBranchName || '', user: search }));
        if (stationUsers) {
            let selectedUser: any;

            selectedUser = stationUsers.find((u: any, i: number) => u.fullName === search);
            if (selectedUser) {
                props.onChange({
                    BranchId: undefined,
                    stationUserId: selectedUser.id
                });
                // console.log('StationUserSelect selectedUser', selectedUser);
            }

        }
        // saveStateData();
    }

    const clearStationUserName = () => {
        setStationUserName('');
        props.onChange({
            BranchId: selectedBranchObject ? selectedBranchObject.id : undefined,
            stationUserId: undefined
        });
        let uList = stationUsersAll;
        if (selectedBranchObject) {
            uList = getBranchUsers(selectedBranchObject);
        }
        setStationUsers(uList);
        // saveStateData();
    }

    const getSubBranches = (branch: any) => {
        if (branch.children) {
            return branch.children;
        }
    }

    const saveStateData = () => {
        // const data: any = {}
        // if (projectName) {
        //     console.log('saveStateData projectName', projectName)
        //    data.projectName = projectName;
        // }
        // if (subBranchName) {
        //     console.log('saveStateData subBranchName', projectName)
        //     data.subBranchName = subBranchName;
        // }
        // if (stationUserName) {
        //     console.log('saveStateData stationUserName', projectName)
        //     data.stationUserName = stationUserName;
        // }
        // localStorage.setItem('savedStationSelectState', JSON.stringify(data))
    }


    const getUsersListByBranch = (branch: any, users: any[]) => {
        let branchUsers: any[] = [];
        if (users && users.length > 0) {
            branchUsers = users.filter((u: any, i: number) => u.branchId === branch.id);
            if (branch.branchManagerId) {
                const branchManager = users.find((u: any, i: number) => u.id === branch.branchManagerId)
                if (branchManager) {
                    branchUsers.push(branchManager);
                }
            }
            if (branch.children && branch.children.length > 0) {
                branch.children.forEach((b: any) => {
                    const subBranchUsers = users.filter((u: any, i: number) => u.branchId === b.id);
                    if (b.branchManagerId) {
                        const branchManager = users.find((u: any, i: number) => u.id === b.branchManagerId)
                        if (branchManager) {
                            branchUsers.push(branchManager);
                        }
                    }
                    if (subBranchUsers && subBranchUsers.length > 0) {
                        branchUsers = [...branchUsers, ...subBranchUsers]
                    }
                });
            }
        }
        return branchUsers;
    }

    const buildData = () => {
        if (branches && branches.length > 0) {
            const rootBranches = branches.filter((b: any) => b.parentId === null && b.children.length > 0)
            // console.log('rootBranches', rootBranches)
            setProjects(rootBranches);
            const loggedUserData = localStorage.getItem('loggedUser')
            if (loggedUserData && loggedUserData !== '') {
                const user = JSON.parse(loggedUserData);
                if (user && user.role == '2' || user.role == '1') {
                    if (user.role == '2') {
                        let subBranchesList: any[] = [];
                        rootBranches.forEach((branch: any) => {
                            const children = getSubBranches(branch);
                            subBranchesList = [...subBranchesList, ...children];
                        });
                        // console.log('subBranches', subBranchesList)
                        setSubBranches(subBranchesList);
                        setSubBranchesAll(subBranchesList);
                        setProjectDisabled(true);
                        let subBranchesUsers: any[] = [];
                        // setSelectedProjectObject(selectedBranch);

                        rootBranches[0].children.forEach((b: any) => {
                            if (props.data.users && props.data.users.length > 0) {
                                const users: any[] = getUsersListByBranch(b, props.data.users);
                                // getBranchUsers
                                subBranchesUsers = [...subBranchesUsers, ...users];
                            }
                        })

                        if (subBranchesUsers && subBranchesUsers.length > 0) {
                            // console.log('setStationUsers 2', subBranchesUsers)
                            setStationUsers(subBranchesUsers);
                        }

                    } else if (user.role == '1') {
                        let subBranches = branches.find((b: any) => b.parentId 
                        && b.address && b.address !== ''
                    );
                        if (subBranches) {
                            setSubBranches([subBranches]);
                            setSubBranchesAll([subBranches]);
                            setSubBranchName(subBranches.name);
                            setSelectedBranchObject(subBranches);
                            props.onChange({
                                BranchId: subBranches.id,
                                stationUserId: undefined
                            });
                            let subBranchesUsers: any[] = [];

                            subBranches.children.forEach((b: any) => {
                                if (props.data.users && props.data.users.length > 0) {
                                    const users: any[] = getUsersListByBranch(b, props.data.users);
                                    // getBranchUsers
                                    subBranchesUsers = [...subBranchesUsers, ...users];
                                }
                            })
                            if (subBranchesUsers && subBranchesUsers.length > 0) {
                                // console.log('setStationUsers 1', subBranchesUsers)
                                setStationUsers(subBranchesUsers);
                            }
                            setProjectDisabled(true);
                            setBranchDisabled(true);

                        }
                    }

                    if (rootBranches && rootBranches.length > 0) {
                        setProjectName(rootBranches[0].name);
                        // setProjectDisabled(true);
                    }
                } else {


                    let subBranchesList: any[] = [];
                    rootBranches.forEach((branch: any) => {
                        const children = getSubBranches(branch);
                        subBranchesList = [...subBranchesList, ...children];
                    });
                    // console.log('subBranches', subBranchesList)
                    setSubBranches(subBranchesList);
                    setSubBranchesAll(subBranchesList);

                    if (users && users.length > 0 && stationUsers && stationUsers.length === 0) {
                        // const stations = users.filter((u: any, i: number) => u.branchId === selectedBranch.id)
                        // console.log('setStationUsers users 346', users);
                        setStationUsers(users);
                        setStationUsersAll(users)
                    }
                }

            }

        }

    }

    const emptyFunc = () => { }

    useEffect(() => {
        // console.log('StationUserSelect props data changed', props.data);
        if (props.data.branches && props.data.branches.length > 0 && !branches) {
            setBranches(props.data.branches);

        }
        if (props.data.users && props.data.users.length > 0 && !users) {
            setUsers(props.data.users);
        }
        //if press clearFilter, clear the branch, project and user names by user role
        if (props.data.clearFilter) {
            const loggedUserData = localStorage.getItem('loggedUser')
            if (loggedUserData && loggedUserData !== '') {
                const user = JSON.parse(loggedUserData);
                if (user.role == '3' || user.role == '4') {
                    setUserDisabled(true);
                    setStationUserName(user.name);
                    props.onChange({
                        BranchId: undefined,
                        stationUserId: user.id
                    });
                } else if (user.role == '2') {
                    setSubBranchName('');
                    setStationUserName('');
                } else if (user.role == '1') {
                    setStationUserName('');
                } else {
                    setProjectName('');
                    setSubBranchName('');
                    setStationUserName('');
                    const sbList = subBranchesAll
                    setSubBranches(sbList);
                    const uList = stationUsersAll;
                    console.log('setStationUsers 373', uList)
                    setStationUsers(uList);
                }
            }
        }
        // if(props.data.saveState) {
        //     saveStateData();
        // }
    }, [props.data])

    useEffect(() => {
        buildData();
    }, [branches])

    useEffect(() => {
        if (projects && projects.length > 0) {
        }
    }, [projects])

    useEffect(() => {
        const loggedUserData = localStorage.getItem('loggedUser')
        if (loggedUserData && loggedUserData !== '') {
            const user = JSON.parse(loggedUserData);
            if (user && user.id && (user.role == '3' || user.role == '4')) {
                setUserDisabled(true);
                setStationUserName(user.name);
                props.onChange({
                    BranchId: undefined,
                    stationUserId: user.id
                });
            }
        }

        if (brunchesData.project && brunchesData.project !== '') {
            setProjectName(brunchesData.project);
        }
        if (brunchesData.branch && brunchesData.branch !== '') {
            setSubBranchName(brunchesData.branch);
        }
        if (brunchesData.user && brunchesData.user !== '') {
            setStationUserName(brunchesData.user);
        }

        setIsLoaded(true);
    }, [])


    return (
        <>
            <div className="filter-input">
                <input type='text'
                    list="projects_list"
                    placeholder='פרויקט'
                    onChange={(e: any) => onProjectChange(e)}
                    value={projectName}
                    disabled={projectDisabled}
                />
                <datalist id="projects_list">
                    {projects.map((o: any, i) => <option key={i} value={o.name}>{o.name}</option>)}
                </datalist>
                {!projectDisabled &&
                    <div className={`icon x-clear pointer ${projectName === undefined || projectName === '' ? 'hide' : ''}`} onClick={clearProjectName}></div>
                }
            </div>
            <div className="filter-input">
                <input type='text'
                    list="subBranches_list"
                    placeholder='סניף'
                    onChange={(e: any) => onSubBranchChange(e)}
                    value={subBranchName}
                    disabled={branchDisabled}
                />
                <datalist id="subBranches_list">
                    {subBranches && subBranches.map((o: any, i) => <option key={i} value={o.name}>{o.name}</option>)}
                </datalist>
                {!branchDisabled &&
                    <div className={`icon x-clear pointer ${subBranchName === undefined || subBranchName === '' ? 'hide' : ''}`} onClick={clearSubBranchName}></div>
                }
            </div>
            <div className="filter-input">
                <input type='text'
                    list="stationUsers_list"
                    placeholder='עמדה'
                    onChange={(e: any) => onStationUserChange(e)}
                    value={stationUserName}
                    disabled={userDisabled}
                />
                <datalist id="stationUsers_list">
                    {stationUsers && stationUsers.map((o: any, i) => <option key={i} value={o.fullName}>{o.fullName}</option>)}
                </datalist>
                {!userDisabled &&
                    <div className={`icon x-clear pointer ${stationUserName === undefined || stationUserName === '' ? 'hide' : ''}`} onClick={clearStationUserName}></div>
                }
            </div>
        </>
    )
}

export default StationUserSelect;